<template>
  <section class="block">
    <label class="label">Professional summary (optional)</label>
    <textarea
      v-model="model"
      class="textarea"
      rows="4"
      maxlength="1000"
      placeholder="Brief summary of your professional background…"
    />
    <span class="hint">{{ model.length }}/1000</span>

    <label class="reuse-row">
      <input
        type="checkbox"
        class="reuse-checkbox"
        :checked="reuseProfessionalSummary"
        @change="onReuseChange"
      />
      <span class="reuse-text">
        <span class="reuse-title">Use my professional summary on generated resumes</span>
        <span class="reuse-hint">
          When checked, each tailored resume keeps this summary as-is.
          When unchecked, AI writes a short summary for the job (uses your real years of experience from your work history, or omits years if unclear).
        </span>
      </span>
    </label>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: { type: String, default: '' },
  reuseProfessionalSummary: { type: Boolean, default: false },
});
const emit = defineEmits(['update:modelValue', 'update:reuseProfessionalSummary']);

const model = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v ?? '')
});

function onReuseChange(e) {
  emit('update:reuseProfessionalSummary', Boolean(e?.target?.checked));
}
</script>

<style scoped>
.block { margin-bottom: 0; }
.label { display: block; font-weight: 600; margin-bottom: 0.35rem; color: var(--text-primary); }
.textarea {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
  background: #ffffff;
  color: var(--text-primary);
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.textarea::placeholder { color: var(--text-muted); opacity: 1; }
.textarea:hover:not(:disabled) { border-color: var(--input-border-hover, var(--border)); }
.textarea:focus {
  outline: none;
  border-color: var(--focus-ring);
  box-shadow: 0 0 0 2px var(--focus-ring);
}
.hint { font-size: 0.8rem; color: var(--text-secondary); display: block; margin-top: 0.25rem; }

.reuse-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 14px;
  cursor: pointer;
  user-select: none;
}
.reuse-checkbox {
  margin-top: 3px;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  accent-color: var(--focus-ring, #2563eb);
  cursor: pointer;
}
.reuse-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.reuse-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}
.reuse-hint {
  font-size: 12px;
  line-height: 1.4;
  color: var(--text-secondary);
}
</style>
